import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { getValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
import "./inner-page-navigation.scss";
import { QueryRequestHelper } from "@_common/query-request-helper";

export default function ShowCauseNoticeNavigation(props: any) {
  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = urlParamsFun();

  return (
    <>
      <div className="task-license-subheader show-cause-notice-subheader">
        <div className="inner-page-navigation-with-back-cta-buttons position-relative">
          <div className="container-fluid  d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <NavLink to={`/report/show-cause-notice?${mainQueryRequest}`} className="">
                <img
                  src="/images/back-link.svg"
                  className="img-fluid"
                  height={24}
                  width={24}
                />
              </NavLink>

              <div className="inner-page-navigation-with-back-cta-button__header">
                <h4 className="inner-page-navigation-with-back-cta-button__header-title"></h4>
              </div>
              <ul className="inner-page-navigation-with-back-cta-buttons__navigation d-inline-flex position-absolute">
                {!props.id && (
                  <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                    <NavLink
                      to={`/report/show-cause-notice/add`}
                      className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                    >
                      Add
                    </NavLink>
                  </li>
                )}
                {props.id && props.id !== "undefined" && (
                  <>
                    <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                      <NavLink
                        to={`/report/show-cause-notice/edit/${props.id}`}
                        className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                      >
                        Details
                      </NavLink>
                    </li>
                    {/* <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                      <NavLink
                        to={`/report/show-cause-notice/details/${props.id}`}
                        className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                      >
                        Details
                      </NavLink>
                    </li> */}
                    <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                      <NavLink
                        to={`/report/show-cause-notice/history/${props.id}`}
                        className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                      >
                        History
                      </NavLink>
                    </li>
                  </>
                )}
              </ul>
            </div>
            <div className="d-flex align-items-center">
              {getValue(props, `isTaskHistorySearch`, false) && (
                <>
                  <RightMenuHeaders
                    //search
                    isSearch={true}
                    searchInput={props.searchInput}
                    showSearchTextbox={props.showSearchTextbox}
                    toggleSearch={props.toggleSearch}
                    toggleSearchClose={props.toggleSearchClose}
                    handleChangeSearch={props.handleChangeSearch}
                  />
                </>
              )}
                
              {getValue(props, `permissions`, []).includes("update") ||
              getValue(props, `permissions`, []).includes("create") ? (
                <div className="ms-2">
                  {props.save ? (
                    props.submitLoading ? (
                      <button className="ascent-button  ascent-button--header-buttons ascent-button--primary">
                        Please wait...
                      </button>
                    ) : window.location.pathname.split("/")[3] === "edit" ||
                      window.location.pathname.split("/")[3] === "add" ? (
                      <button
                        className={`ascent-button  ascent-button--header-buttons ascent-button--${
                          // !props.isChanged ? "secondary" : "primary"
                          "secondary"
                        }`}
                        onClick={props.handleSubmit}
                        // disabled={props.isChanged}
                      >
                        {!props.id ? "Create" : "Update"}
                      </button>
                    ) : window.location.pathname.split("/")[3] === "history" ? (
                      <button
                        className={`ascent-button  ascent-button--header-buttons ascent-button--${
                          // !props.isChanged ? "secondary" : "primary"
                          "secondary"
                        }`}
                        onClick={props.handleSubmit}
                        // disabled={props.isChanged}
                      >
                        {"Add Status"}
                      </button>
                    ) : (
                      <button
                        className={`ascent-button  ascent-button--header-buttons ascent-button--`}
                        onClick={props.handleSubmit}
                        // disabled={props.isChanged}
                      ></button>
                    )
                  ) : null}
                </div>
              ) : null}
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
}